export default __webpack_public_path__ + "static/Gary.GrunewaldViceChairSouthWest_social-061b330ec45b2f6454ab9dbb7a6aacd9.jpg";